import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import { useAuth } from '../utils/AuthContext';

const AddAgent = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [agencyData, setAgencyData] = useState({
    agencyName: '',
    description: '',
    contactPerson: '',
    contactNumber: '',
    emailAddress: ''
  });
  const [saving, setSaving] = useState(false);

  const handleInputChange = (field, value) => {
    setAgencyData({
      ...agencyData,
      [field]: value
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      // Check if all required fields are filled
      if (!agencyData.agencyName || !agencyData.contactPerson || 
          !agencyData.contactNumber || !agencyData.emailAddress) {
        alert('Please fill in all required fields');
        return;
      }

      // Validate contact number length
      if (agencyData.contactNumber.length > 20) {
        alert('Contact number cannot exceed 20 characters');
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(agencyData.emailAddress)) {
        alert('Please enter a valid email address');
        return;
      }

      const requestBody = {
        userId: user?.id || 1,
        agencyName: agencyData.agencyName,
        description: agencyData.description || '',
        contactPerson: agencyData.contactPerson,
        contactNumber: agencyData.contactNumber,
        emailAddress: agencyData.emailAddress
      };

      console.log('Sending agency data:', requestBody);

      const result = await apiService.post('/agencies', requestBody);
      console.log('Agency created successfully:', result);
      
      alert('Agency created successfully!');
      
      // Navigate back to manage agencies
      navigate('/agents');
      
    } catch (err) {
      console.error('Error creating agency:', err);
      alert('Failed to create agency. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Add Agency</h1>
      </div>

      <div className="content-container">
        <div className="form-section">
          <h3>Agency Information</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="agencyName">Agency Name:</label>
              <input
                type="text"
                id="agencyName"
                className="form-input"
                value={agencyData.agencyName}
                onChange={(e) => handleInputChange('agencyName', e.target.value)}
                required
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                className="form-input"
                value={agencyData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                rows="4"
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="contactPerson">Contact Person:</label>
              <input
                type="text"
                id="contactPerson"
                className="form-input"
                value={agencyData.contactPerson}
                onChange={(e) => handleInputChange('contactPerson', e.target.value)}
                required
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="contactNumber">Contact Number:</label>
              <input
                type="text"
                id="contactNumber"
                className="form-input"
                value={agencyData.contactNumber}
                onChange={(e) => handleInputChange('contactNumber', e.target.value)}
                maxLength="20"
                required
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="emailAddress">Email Address:</label>
              <input
                type="email"
                id="emailAddress"
                className="form-input"
                value={agencyData.emailAddress}
                onChange={(e) => handleInputChange('emailAddress', e.target.value)}
                required
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Creating Agency...' : 'Create Agency'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAgent;
